import React from "react";
import { useTranslation } from "react-i18next";
import { Banner } from "@rentablo/components";

interface AddManuallyMessageProps {
  type?: "success" | "error";
  message?: string;
}

export const AddManuallyMessage = ({
  message,
  type,
}: AddManuallyMessageProps) => {
  const { t } = useTranslation();

  if (type === "error") {
    return (
      <Banner
        data-testid="result-alert-error"
        type="error"
        displayDefaultIcon
        text={message}
      />
    );
  }

  if (type === "success") {
    return (
      <Banner
        data-testid="result-alert-success"
        type="success"
        text={t("addManuallyPage.form.messages.success")}
      />
    );
  }

  return null;
};
